import './ValidationAnimationContainer-04125429.css';

var classes = {"Animation":"prc-components-Animation-zcKZT"};

export { classes as default };
